import safeStringify from 'fast-safe-stringify';

export function safeJsonParse<T>(value: string): T | undefined {
  if (!value) return;
  try {
    return JSON.parse(value);
  } catch (e) {
    return;
  }
}

export function safeJsonStringify(value: any) {
  try {
    return safeStringify(value);
  } catch (error) {
    return;
  }
}
